module.exports = __webpack_public_path__ + "static/img/Xihua_WANG.1244c42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Xihua_WANG.png
// module id = fKYu
// module chunks = 1